import React from "react";
import Hero from "components/hero/Hero";
import Footer from "components/footers/FiveColumnDark";
import FrequentlyAskedQue from "components/faqs/SingleCol";
import ItServicesList from "components/cards/ItServicesList";
import CompanyProfile from "components/features/CompanyProfile";
import CompanyLocation from "components/features/CompanyLocation";
import SubCompanyProfile from "components/cards/SubCompanyProfile";
import ProjectShowCase from "components/project-showcase/ProjectShowCase";
// import HistoryOverview from "components/history/HistoryOverview";
import News from "components/news/News";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import GlobalStyle from "helpers/GlobalStyle";
import useScreenSize from "helpers/useScreenSize";

const HomePage = () => {
  // Use the custom hook to get screen size information
  const { isXs } = useScreenSize(); //** XS | SM | MD use same breakpoint  **/
  return (
    <div>
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        <div className={!isXs ? "gradient-container" : ""}>
          <News isXs={isXs} />
        </div>
        <ItServicesList isXs={isXs} />
        <ProjectShowCase isXs={isXs} />
        <CompanyProfile isXs={isXs} />
        <div className={!isXs ? "gradient-container" : ""}>
          <CompanyLocation isXs={isXs} />
        </div>
        <SubCompanyProfile isXs={isXs} />
        <div className={!isXs ? "gradient-container" : ""}>
          <FrequentlyAskedQue isXs={isXs} />
        </div>
        {/* <HistoryOverview isXs={isXs} /> */}
        <Footer isXs={isXs} />
      </SplashAnimationContainer>
    </div>
  );
};
export default HomePage;
